// src/utils/jsonToMarkdown.js

// 标题样式：snake_case → Title Case
const titleCase = (s) =>
  String(s || '')
    .replace(/_/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());

// 将任意值转为 Markdown 片段
const fieldToMarkdown = (fieldName, fieldContent, level = 2) => {
  let md = `${'#'.repeat(level)} ${titleCase(fieldName)}\n\n`;
  const type = Object.prototype.toString.call(fieldContent);

  const emitInline = (v) => {
    if (v === null || v === undefined) return '`null`';
    if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') return String(v);
    return '`' + JSON.stringify(v) + '`';
  };

  if (type === '[object String]' || type === '[object Number]' || type === '[object Boolean]') {
    md += `${fieldContent}\n\n`;
  } else if (type === '[object Array]') {
    const arr = fieldContent;
    if (arr.length === 0) {
      md += `- (empty)\n\n`;
    } else {
      for (const item of arr) {
        const t = Object.prototype.toString.call(item);
        if (t === '[object String]' || t === '[object Number]' || t === '[object Boolean]') {
          md += `- ${item}\n`;
        } else if (t === '[object Object]') {
          // 数组里是对象：展开为二级列表
          md += `- \n`;
          for (const [k, v] of Object.entries(item)) {
            md += `  - **${titleCase(k)}**: ${emitInline(v)}\n`;
          }
        } else {
          md += `- \`${JSON.stringify(item)}\`\n`;
        }
      }
      md += `\n`;
    }
  } else if (type === '[object Object]') {
    // 对象：逐键处理（字段多时更可读）
    for (const [k, v] of Object.entries(fieldContent)) {
      const t = Object.prototype.toString.call(v);
      if (t === '[object Array]') {
        md += fieldToMarkdown(k, v, level + 1);
      } else if (t === '[object Object]') {
        md += `${'#'.repeat(level + 1)} ${titleCase(k)}\n\n`;
        for (const [kk, vv] of Object.entries(v)) {
          md += fieldToMarkdown(kk, vv, level + 2);
        }
      } else {
        md += `${'#'.repeat(level + 1)} ${titleCase(k)}\n\n${emitInline(v)}\n\n`;
      }
    }
  } else {
    // 其他类型统一 JSON 内联
    md += `\`${String(fieldContent)}\`\n\n`;
  }
  return md;
};

// 顶层：把 review_results 对象整体转为 Markdown 字符串
export const reviewResultsToMarkdown = (
  reviewResults,
  { addHeader = true, addNote = true } = {}
) => {
  if (!reviewResults) return '';
  let md = '';
  if (addHeader) {
    md += `# AI Review (auto-generated)\n\n`;
  }
  for (const [key, val] of Object.entries(reviewResults)) {
    md += fieldToMarkdown(key, val, 2);
  }
  if (addNote) {
    md +=
      `> Note: AI-generated review comments are for authors' reference only and did not participate in the decision-making process.\n`;
  }
  return md;
};

// 尝试将字符串安全解析为对象；解析失败则包成 { text: 原串 }
export const coerceToObject = (maybeJsonString) => {
  if (typeof maybeJsonString === 'string') {
    try {
      return JSON.parse(maybeJsonString);
    } catch {
      return { text: maybeJsonString };
    }
  }
  return maybeJsonString;
};
